<template>
    <div>
        <v-card>
            <v-card-title class="pb-0 headline">Filtro de historiales</v-card-title>
            <v-card-text class="pt-0">
                <v-flex xs12 sm12>
                    <template>
                        <v-alert
                            v-model="showErrorDataLoadedAlert"
                            type="error"
                            dismissible
                            transition="scale-transition"
                            dark
                        >
                            No se han podido cargar todos los datos necesarios para este filtro.
                            <br />
                            Intente cargar el filtro nuevamente.
                        </v-alert>
                        <v-container style="max-width: 500px" class="pa-1">
                            <v-autocomplete
                                v-model="selectedCampos"
                                class="pt-0"
                                :items="inputs"
                                item-value="text"
                                return-object
                                hide-selected
                                placeholder="Selecciones los campos para filtrar..."
                                multiple
                                persistent-hint
                                deletable-chips
                                small-chips
                                dense
                                clearable
                                tags
                                ref="selectedCamposRef"
                            >
                            </v-autocomplete>

                            <v-divider></v-divider>

                            <v-flex class="my-1" align="center">
                                <v-layout>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 black--text">
                                            Filtros: {{ selectedCampos.length }}
                                        </strong>
                                    </v-fade-transition>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 green--text"> Activos: {{ activeFilters }} </strong>
                                    </v-fade-transition>

                                    <v-spacer></v-spacer>

                                    <v-btn color="success" small class="my-0" @click="applyFilter()">
                                        Aplicar
                                    </v-btn>
                                </v-layout>
                            </v-flex>

                            <v-divider class="mb-4"></v-divider>

                            <v-card v-if="selectedCampos.length > 0">
                                <v-list>
                                    <v-slide-y-transition class="py-0" group tag="v-list">
                                        <template v-for="(campo, i) in selectedCampos">
                                            <v-divider v-if="i !== 0" :key="`${i}-divider`" class="pb-0"></v-divider>
                                            <v-list-tile :key="campo.id">
                                                <v-list-tile-action>
                                                    <v-checkbox
                                                        v-model="campo.activo"
                                                        :disabled="selectedCampos[i].value.length === 0"
                                                        color="info"
                                                        class="mt-3"
                                                    >
                                                    </v-checkbox>
                                                </v-list-tile-action>

                                                <v-list-tile-content>
                                                    <template v-if="campo.text === 'Tipo'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { nombre: 'Insertado', value: 'created' },
                                                                { nombre: 'Modificado', value: 'updated' },
                                                                { nombre: 'Eliminado', value: 'deleted' },
                                                                { nombre: 'Deshabilitado', value: 'disabled' }
                                                            ]"
                                                            :label="campo.text"
                                                            item-text="nombre"
                                                            item-value="value"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-if="campo.text === 'Creado en'">
                                                        <v-daterange
                                                            v-model="inputs[campo.id - 1].value"
                                                            start-label="d/m/a"
                                                            end-label="d/m/a"
                                                            separator-label="-"
                                                            preset-label="Prestablecidos"
                                                            locale="es"
                                                            display-format="dd/MM/yyyy"
                                                            label="Creado en"
                                                            :presets="presets"
                                                            :input-props="{
                                                                label: 'Rango',
                                                                style: { width: '245px' },
                                                                class: 'mt-3'
                                                            }"
                                                            :action-labels="{
                                                                apply: 'Aplicar',
                                                                cancel: 'Cancelar',
                                                                reset: 'Resetear'
                                                            }"
                                                        ></v-daterange>
                                                    </template>

                                                    <template v-if="campo.text === 'Modificado en'">
                                                        <v-daterange
                                                            v-model="inputs[campo.id - 1].value"
                                                            start-label="d/m/a"
                                                            end-label="d/m/a"
                                                            separator-label="-"
                                                            preset-label="Prestablecidos"
                                                            locale="es"
                                                            display-format="dd/MM/yyyy"
                                                            label="Modificado en"
                                                            :presets="presets"
                                                            :input-props="{
                                                                label: 'Rango',
                                                                style: { width: '245px' },
                                                                class: 'mt-3'
                                                            }"
                                                            :action-labels="{
                                                                apply: 'Aplicar',
                                                                cancel: 'Cancelar',
                                                                reset: 'Resetear'
                                                            }"
                                                        ></v-daterange>
                                                    </template>

                                                    <template
                                                        v-if="
                                                            campo.text === 'Creado por' ||
                                                                campo.text === 'Modificado por'
                                                        "
                                                    >
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="USERS"
                                                            label="Usuario"
                                                            item-text="username"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>
                                                </v-list-tile-content>

                                                <v-spacer></v-spacer>

                                                <v-scroll-x-transition>
                                                    <v-icon v-if="campo.activo" color="success">
                                                        fa-check
                                                    </v-icon>
                                                </v-scroll-x-transition>
                                            </v-list-tile>
                                        </template>
                                    </v-slide-y-transition>
                                </v-list>
                            </v-card>
                        </v-container>
                    </template>
                </v-flex>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Util from "@/util"
import { mapGetters } from "vuex"
import { VDaterange } from "vuetify-daterange-picker"
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css"
import { format, subDays, getDaysInMonth, getYear, getMonth } from "date-fns"

export default {
    name: "CustomFilterHistorial",
    components: { VDaterange },
    props: {
        internalState: { type: Object, default: null }
    },
    data: () => ({
        inputs: Util.HistorialCampos(),
        selectedCampos: [],

        //saber si se cargaron todos los datos necesarios para seleccionar
        showErrorDataLoadedAlert: false,

        //rangos prestablecidos
        presets: [
            {
                label: "Últimos 30 días",
                range: [format(subDays(new Date(), 30), "yyyy-MM-dd"), format(subDays(new Date(), 1), "yyyy-MM-dd")]
            },
            {
                label: "Mes anterior",
                range: [
                    format(new Date(getYear(new Date()), getMonth(new Date()) - 1, 1), "yyyy-MM-dd"),
                    format(
                        new Date(
                            getYear(new Date()),
                            getMonth(new Date()) - 1,
                            getDaysInMonth(new Date(getYear(new Date()), getMonth(new Date()) - 1))
                        ),
                        "yyyy-MM-dd"
                    )
                ]
            },
            {
                label: "Hoy",
                range: [format(new Date(), "yyyy-MM-dd"), format(new Date(), "yyyy-MM-dd")]
            },
            {
                label: "Ayer",
                range: [format(subDays(new Date(), 1), "yyyy-MM-dd"), format(subDays(new Date(), 1), "yyyy-MM-dd")]
            }
        ]
    }),
    methods: {
        applyFilter() {
            let customFilter = ""
            this.selectedCampos.forEach(campo => {
                if (campo.activo) {
                    if (campo.attribute === "created_at" && campo.value.start && campo.value.start !== "") {
                        let [sY, sM, sD] = campo.value.start.split("-")
                        let startDate = format(new Date(sY, sM - 1, sD, 0, 0, 0), "t")
                        let [eY, eM, eD] = campo.value.end.split("-")
                        let endDate = format(new Date(eY, eM - 1, eD, 23, 59, 59), "t")
                        customFilter = customFilter + `created_at_start=${startDate}&created_at_end=${endDate}&`
                    } else if (campo.attribute === "updated_at" && campo.value.start && campo.value.start !== "") {
                        let [sY, sM, sD] = campo.value.start.split("-")
                        let startDate = format(new Date(sY, sM - 1, sD, 0, 0, 0), "t")
                        let [eY, eM, eD] = campo.value.end.split("-")
                        let endDate = format(new Date(eY, eM - 1, eD, 23, 59, 59), "t")
                        customFilter = customFilter + `updated_at_start=${startDate}&updated_at_end=${endDate}&`
                    } else {
                        customFilter = customFilter + `${campo.attribute}=${campo.value}&`
                    }
                }
            })
            customFilter = customFilter.slice(0, -1)
            return this.$emit("applyFilter", {
                customFilter: customFilter,
                activeFilters: this.activeFilters,
                internalState: {
                    inputs: this.inputs,
                    selectedCampos: this.selectedCampos
                }
            })
        }
    },

    computed: {
        activeFilters() {
            return this.selectedCampos.filter(campo => campo.activo).length
        },

        ...mapGetters(["USERS"])
    },

    watch: {
        selectedCampos() {
            setTimeout(() => {
                this.$refs.selectedCamposRef.isMenuActive = false
            }, 50)
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_USERS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.internalState) {
            this.selectedCampos = this.internalState.selectedCampos
            this.inputs = this.internalState.inputs
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
